function onDocumentReady() {
	let els = document.querySelectorAll('.testimonial-slider');
	[...els].map(initializePhotoCarousel);
}

function initializePhotoCarousel(el) {
	let testimonialsNumber = jQuery('.testimonials-slider-item', el).length;
	if (testimonialsNumber === 1) {
		jQuery('.slider-testimonials', el).addClass('single-testimonial');
	} else if (testimonialsNumber > 3) {
		jQuery('.slider-testimonials', el).slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: 0,
			infinite: true,
			// autoplay: true,
			prevArrow: '<button class="slick-arrow slick-next"></button>',
			nextArrow: '<button class="slick-arrow slick-prev"></button>',
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						adaptiveHeight: true,
					}
				}
			]
		});
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
